import React from "react";
import {Box, Button, Container, Typography} from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import {Link} from "react-router-dom";
import {colors, displayFont} from "../../styling/GlobalTheme";
import {dateRange} from "./format";
import Reveal from "./Reveal";
import useFeaturedRace from "./useFeaturedRace";

const IMG = process.env.PUBLIC_URL + "/images/course2027/";

/* Présentation de la course FIS & Children (accueil et page Course) */
export default function RacePromo({full}: { full?: boolean }) {
    const race = useFeaturedRace();
    const points = [
        ["FIS", "Course inscrite au calendrier officiel de la Fédération Internationale de Ski"],
        ["Children", "Les jeunes talents du télémark sur le même parcours que l'élite"],
        ["Public", "Accès libre : venez encourager les coureurs au bord de la piste"],
    ];
    return (
        <Box component="section" sx={{py: {xs: 8, md: 12}, background: `linear-gradient(180deg, #fff, ${colors.snow})`}}>
            <Container maxWidth="lg" sx={{display: "grid", gridTemplateColumns: {xs: "1fr", md: "1.05fr 1fr"}, gap: {xs: 5, md: 8}, alignItems: "center"}}>
                <Reveal>
                    <Box sx={{position: "relative", display: "grid", gridTemplateColumns: "1fr .6fr", gridTemplateRows: "1fr 1fr", gap: 1.5, aspectRatio: "4 / 3"}}>
                        <Box sx={{gridRow: "span 2", borderRadius: 5, overflow: "hidden", boxShadow: "0 30px 60px rgba(11,18,32,.25)"}}>
                            <img src={IMG + "g6.jpg"} alt="Course FIS de télémark" style={{width: "100%", height: "100%", objectFit: "cover"}}/>
                        </Box>
                        <Box sx={{borderRadius: 4, overflow: "hidden"}}><img src={IMG + "children.jpg"} alt="Course Children" style={{width: "100%", height: "100%", objectFit: "cover"}}/></Box>
                        <Box sx={{borderRadius: 4, overflow: "hidden"}}><img src={IMG + "g3.jpg"} alt="Télémark" style={{width: "100%", height: "100%", objectFit: "cover"}}/></Box>
                        <Box sx={{position: "absolute", top: 16, left: 16, bgcolor: colors.red, color: "#fff", borderRadius: 3, px: 2, py: 1.2, textAlign: "center", boxShadow: "0 10px 20px rgba(230,57,70,.4)"}}>
                            <Typography sx={{fontFamily: displayFont, fontSize: "2.2rem", lineHeight: .9}}>FIS</Typography>
                            <Typography sx={{fontSize: ".65rem", fontWeight: 800, letterSpacing: 1, textTransform: "uppercase"}}>Telemark</Typography>
                        </Box>
                    </Box>
                </Reveal>
                <Reveal delay={150}>
                    <Typography sx={{color: colors.red, fontWeight: 800, letterSpacing: 2, textTransform: "uppercase", fontSize: ".8rem"}}>Saison 2026 – 2027</Typography>
                    <Typography variant="h2" sx={{fontSize: {xs: "2.8rem", md: "3.8rem"}}}>Course FIS &amp; Children</Typography>
                    <Typography sx={{fontWeight: 700, fontSize: "1.2rem", my: 1.5}}>
                        📅 {dateRange(race.start, race.end)}{race.place ? ` · 📍 ${race.place}` : ""}
                    </Typography>
                    <Typography sx={{color: "text.secondary"}}>
                        Deux jours de télémark organisés par le Mouch'Paba : les meilleurs coureurs internationaux sur la course FIS
                        et la relève sur les épreuves Children. Saut, virage relevé (360), skating et génuflexion : venez découvrir
                        la discipline la plus spectaculaire du ski alpin.
                    </Typography>
                    <Box sx={{my: 3, display: "grid", gap: 1.5}}>
                        {points.map(([k, v]) => (
                            <Box key={k} sx={{display: "flex", gap: 2, alignItems: "baseline"}}>
                                <Typography sx={{flex: "0 0 92px", fontFamily: displayFont, fontSize: "1.5rem", letterSpacing: 1}}>{k}</Typography>
                                <Typography sx={{color: "text.secondary"}}>{v}</Typography>
                            </Box>
                        ))}
                    </Box>
                    <Box sx={{display: "flex", gap: 1.5, flexWrap: "wrap"}}>
                        <Button size="large" variant="contained" href={race.link} target="_blank" rel="noopener" endIcon={<ArrowOutwardIcon/>}
                                sx={{bgcolor: colors.red, color: "#fff", "&:hover": {bgcolor: "#c92f3b"}}}>
                            Programme &amp; résultats sur fis-ski.com
                        </Button>
                        {full
                            ? <Button size="large" variant="outlined" color="inherit" href="mailto:info@mouchpaba.ch?subject=B%C3%A9n%C3%A9vole%20course%20FIS%202027">Devenir bénévole</Button>
                            : <Button size="large" variant="outlined" color="inherit" component={Link} to="/course">En savoir plus</Button>}
                    </Box>
                </Reveal>
            </Container>
        </Box>
    );
}
